import { useId } from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** sm = compact (36x20), md = 44px-compliant (44x24). Default: md */
  size?: 'sm' | 'md';
  /** Accessible label (sr-only). Required for standalone toggles. */
  label?: string;
  className?: string;
}

export default function Toggle({
  checked,
  onChange,
  disabled = false,
  size = 'md',
  label,
  className = '',
}: ToggleProps) {
  const id = useId();

  const trackSize = size === 'sm' ? 'w-9 h-5' : 'w-11 h-6';
  const thumbSize = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  // Driv on-tilstanden fra `checked`-proppen, IKKE Tailwinds `peer-checked:`.
  // Track/thumb lever inde i <label>, som er sibling til .peer-input'et, så den
  // efterfølgende-sibling-kombinator (`~`) bag peer-checked ramte dem aldrig -
  // den grønne track + forskudte thumb (on-tilstanden) blev derfor aldrig vist.
  const thumbTranslate = checked
    ? size === 'sm' ? 'translate-x-4' : 'translate-x-5'
    : 'translate-x-0';

  return (
    <div className={`relative flex-shrink-0 ${className}`}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="sr-only peer"
        aria-label={label}
      />
      <label htmlFor={id} className={disabled ? 'cursor-not-allowed' : 'cursor-pointer'}>
        {label && <span className="sr-only">{label}</span>}
        <div
          className={`${trackSize} rounded-full transition ${
            checked ? 'bg-green-500' : 'bg-gray-300 dark:bg-gray-500'
          } ${disabled ? 'opacity-50' : ''}`}
        />
        <div
          className={`absolute left-0.5 top-0.5 ${thumbSize} bg-white rounded-full shadow transition ${thumbTranslate}`}
        />
      </label>
    </div>
  );
}
